<template>
  <validation-observer ref="simpleRules">
    <b-overlay
      :show="inProgress"
      rounded="sm"
    >
      <b-form>

      <!-- Icon -->
      <b-form-group
        label="Icon"
        label-for="mc-icon"
      >
        <b-card
          class="icon-card cursor-pointer text-center mb-2 mx-50"
          @click="selectIcon"
        >

          <div class="icon-wrapper">
            <b-avatar
              size="32"
              :variant="item.variant"
            >
              <feather-icon
                :icon="item.icon"
                size="24"
              />
            </b-avatar>
          </div>
          <b-card-text class="icon-name text-truncate mb-0 mt-1">
            {{ item.icon }}
          </b-card-text>
        </b-card>

      </b-form-group>

      <icon-selector
        @selected="setIcon"
      />

      <!-- Variant -->
      <b-form-group
        label="Color"
        label-for="mc-variant"
      >
        <validation-provider
          #default="{ errors }"
          name="Color"
          rules="required"
        >
          <v-select
            id="variant"
            v-model="item.variant"
            :options="optionVariant"
            placeholder="Select color..."
            :state="errors.length > 0 ? false:null"
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Title -->
      <b-form-group
        label="Title"
        label-for="mc-title"
      >
        <validation-provider
          #default="{ errors }"
          name="Title"
          rules="required"
        >
          <b-form-input
            v-model="item.title"
            :state="errors.length > 0 ? false:null"
            placeholder="Title..."
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Body -->
      <b-form-group
        label="Body"
        label-for="mc-body"
      >
        <validation-provider
          #default="{ errors }"
          name="Body"
          rules="required"
        >
          <b-form-textarea
            v-model="item.body"
            :state="errors.length > 0 ? false:null"
            placeholder="Body..."
          />
          <small class="text-danger">{{ $t(errors[0]) }}</small>
        </validation-provider>

      </b-form-group>

      <!-- User Groups -->
      <b-form-group
        label="User Groups"
        label-for="mc-user-groups"
      >
        <v-select
          id="vue-select-user-groups"
          v-model="item.userGroups"
          :options="optionUserGroup"
          :reduce="group => group.id"
          label="groupName"
          placeholder="Select user groups..."
          multiple
          @input="item.userGroups.length == 0 ? item.sendAsMail = false : null"
        />
      </b-form-group>

      <!-- Send As Mail -->
      <b-form-group
        label="Send As Mail"
        label-for="checkbox-send-as-mail"
      >
        <b-form-checkbox
          id="checkbox-send-as-mail"
          v-model="item.sendAsMail"
          name="checkbox-send-as-mail"
          :disabled="item.userGroups.length == 0"
          switch
          class="mt-1"
        >
          <span v-if="item.sendAsMail">{{ $t('Yes') }}</span>
          <span v-if="!item.sendAsMail">{{ $t('No') }}</span>
        </b-form-checkbox>
      </b-form-group>

      </b-form>
    </b-overlay>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BFormTextarea, BFormCheckbox, BCard, BCardText, BAvatar, BOverlay,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import IconSelector from '@/layouts/components/IconSelector.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BFormCheckbox,
    vSelect,
    IconSelector,
    BCard,
    BCardText,
    BAvatar,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      default_item: {
        title: null,
        body: null,
        userGroups: [],
        sendAsMail: false,
        icon: 'InfoIcon',
        variant: 'info',
      },
      required,
      inProgress: false,
      initialUserGroups: [],
      optionUserGroup: [],
      optionVariant: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light-primary', 'light-secondary', 'light-success', 'light-warning', 'light-danger', 'light-info'],
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }

        return this.default_item
      },
    },
  },
  async created() {
    if (this.editItem) {
      this.item = JSON.parse(JSON.stringify(this.editItem))
      // await this.initMessage()
    }
    this.getUserGroupOptions()
  },
  methods: {
    // async initMessage() {
    //   useJwt.axiosIns.get(`message/${this.editItem.id}`).then(response => {
    //     this.item = response.data
    //   })
    // },
    getUserGroupOptions() {
      useJwt.axiosIns.get('usergroup').then(response => {
        this.optionUserGroup = response.data
      })
    },
    selectIcon() {
      this.$bvModal.show('iconSelector')
    },
    setIcon(icon) {
      this.$bvModal.hide('iconSelector')
      this.item.icon = icon
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success && !this.inProgress) {
          this.inProgress = true
          if (this.item.id) {
            useJwt.axiosIns.patch('message', this.item)
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                  this.$root.$emit('refresh_messages')
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.inProgress = false
              })
          } else {
            useJwt.axiosIns.post('message', this.item, {
              params: { sendAsMail: this.item.sendAsMail },
            })
              .then(response => {
                if (response.data) {
                  this.$emit('submit')
                  this.$root.$emit('refresh_messages')
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.inProgress = false
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
